import {request} from '@/helpers/apiClient';
import {REWARDS_CONFIG} from '@/utils/constants/apiConfig/rewardsConfig';
import {REWARD_STATUS} from '@/utils/constants/rewardsConstants';

/**
 * Get reward types from API
 * @returns {Promise} Promise containing reward types data
 */
export const getRewardTypes = async () => {
  return request(REWARDS_CONFIG.REWARD_TYPES);
};

/**
 * Get reward segments from API
 * @returns {Promise} Promise containing reward segments data
 */
export const getRewardSegments = async () => {
  return request(REWARDS_CONFIG.REWARD_SEGMENTS);
};

/**
 * Save reward as draft
 * @param {Object} rewardData - The reward data to save
 * @returns {Promise} Promise containing the save response
 */
export const saveRewardDraft = async (rewardData) => {
  return request(REWARDS_CONFIG.SAVE_DRAFT, {data: rewardData});
};

/**
 * Publish reward
 * @param {Object} rewardData - The reward data to publish
 * @returns {Promise} Promise containing the publish response
 */
export const publishReward = async (rewardData) => {
  const hasId = rewardData && (rewardData.id || rewardData.rewardId);
  const isPublishedOrActiveStatus =
    rewardData &&
    (rewardData.status === REWARD_STATUS.PUBLISHED ||
      rewardData.status === REWARD_STATUS.ACTIVE);

  const config =
    hasId && isPublishedOrActiveStatus
      ? REWARDS_CONFIG.UPDATE_REWARD
      : REWARDS_CONFIG.PUBLISH_REWARD;

  return request(config, {data: rewardData});
};

/**
 * Get reward detail from API
 * @param {Number|string} id - The reward id
 * @returns {Promise} Promise containing the reward detail data
 */
export const getRewardDetail = async (id) => {
  return request(REWARDS_CONFIG.GET_REWARD_DETAIL(id));
};

export const getSegmentsList = (queryParams, searchArr) =>
  request(REWARDS_CONFIG.SEGMENTS_LIST(queryParams), {data: searchArr});

/**
 * Validate if reward name is available (not duplicate).
 * Makes a GET call to rewards/validate-name?name=...
 *
 * API response shape (per contract):
 *   { data: boolean, success: boolean, message: string }
 *   - data: true  => name is available
 *   - data: false => name already exists
 */
export const validateRewardName = (queryParams) =>
  request(REWARDS_CONFIG.VALIDATE_REWARD_NAME, '', queryParams);

/**
 * Revoke reward
 * @param {Object} rewardData - The reward data containing id and applicationId
 * @returns {Promise} Promise containing the revoke response
 */
export const revokeReward = async (rewardData) => {
  return request(REWARDS_CONFIG.REVOKE_REWARD, {data: rewardData});
};

export const getRewardReportDownload = (queryParams) =>
  request(REWARDS_CONFIG.REWARD_REPORT_DOWNLOAD, '', queryParams);
